// Vendor imports
const PropTypes = require('prop-types')
const React = require('react')
// Sibling imports
const TooltipAnchor = require('./components/anchor')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

class WithTooltip extends React.PureComponent {
  constructor(props) {
    super(props)

    this.onDismiss = this.onDismiss.bind(this)
  }

  onDismiss(event) {
    if (this.props.onDismiss) {
      event.stopPropagation()
      this.props.onDismiss(this.props.tooltipKey)
    }
  }

  render() {
    const { children, ...anchorProps } = this.props
    if (!anchorProps.renderBubbleChildren) {
      return children
    }
    return tag(TooltipAnchor, {
      ...anchorProps,
      onDismiss: this.onDismiss
    },
      children
    )
  }
}

WithTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  // Values
  isDismissed: PropTypes.bool,
  tooltipKey: PropTypes.string.isRequired,
  // Render props
  renderBubbleChildren: PropTypes.func,
  // Callbacks
  onDismiss: PropTypes.func.isRequired
}

module.exports = WithTooltip
